import {
  IESDPCaptainReports,
  IESDPCaptainReportsStudent,
  IESDPFreeTimeGraph,
  IESDPGroupTeams,
  IESDPIterationReview,
  IESDPTeam,
  IESDPTeamDocument,
  IESDPTeamDocuments,
  IESDPTeamIteration,
  IESDPTeamMaterials,
  IESDPTeams,
  IESDPTeamUser,
} from '@interfaces/IESDP';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IESDPIterationsQParams } from '@interfaces/IQParams';
import { IUsersPagination } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EESDPViewActions {
  GetTeamRequest = '[ESDP] Get Team Request',
  GetTeamSuccess = '[ESDP] Get Team Success',
  GetTeamFailure = '[ESDP] Get Team Failure',
  ClearGetTeam = '[ESDP] Clear Get Team',

  GetTeamsRequest = '[ESDP] Get Teams Request',
  GetTeamsSuccess = '[ESDP] Get Teams Success',
  GetTeamsFailure = '[ESDP] Get Teams Failure',
  ClearGetTeams = '[ESDP] Clear Get Teams',

  GenerateESDPTeamsRequest = '[ESDP] Generate Teams Request',
  GenerateESDPTeamsSuccess = '[ESDP] Generate Teams Success',
  GenerateESDPTeamsFailure = '[ESDP] Generate Teams Failure',
  ClearGenerateESDPTeams = '[ESDP] Clear Generate Teams',

  ChangeGeneratedESDPTeams = '[ESDP] Change Generated Teams',

  GetFreeTimeGraphRequest = '[ESDP] Free Time Graph Request',
  GetFreeTimeGraphSuccess = '[ESDP] Free Time Graph Success',
  GetFreeTimeGraphFailure = '[ESDP] Free Time Graph Failure',
  ClearGetFreeTimeGraph = '[ESDP] Clear Free Time Graph',

  GetIterationsRequest = '[ESDP] Get Iterations Request',
  GetIterationsSuccess = '[ESDP] Get Iterations Success',
  GetIterationsFailure = '[ESDP] Get Iterations Failure',
  ClearGetIterations = '[ESDP] Clear Get Iterations',

  GetIterationByIdRequest = '[ESDP] Get Iteration By Id Request',
  GetIterationByIdSuccess = '[ESDP] Get Iteration By Id Success',
  GetIterationByIdFailure = '[ESDP] Get Iteration By Id Failure',
  ClearGetIterationById = '[ESDP] Clear Get Iteration By Id',

  GetIterationReviewByIdRequest = '[ESDP] Get Iteration Review By Id Request',
  GetIterationReviewByIdSuccess = '[ESDP] Get Iteration Review By Id Success',
  GetIterationReviewByIdFailure = '[ESDP] Get Iteration Review By Id Failure',
  ClearGetIterationReviewById = '[ESDP] Clear Get Iteration Review By Id',

  SetCurrentIteration = '[ESDP] Set Current Iteration',
  ClearCurrentIteration = '[ESDP] Clear Current Iteration',

  GetTeamStudentsRequest = '[ESDP] Get Team Students Request',
  GetTeamStudentsSuccess = '[ESDP] Get Team Students Success',
  GetTeamStudentsFailure = '[ESDP] Get Team Students Failure',
  ClearGetTeamStudents = '[ESDP] Clear Get Team Students',

  GetTeamMentorsRequest = '[ESDP] Get Team Mentors Request',
  GetTeamMentorsSuccess = '[ESDP] Get Team Mentors Success',
  GetTeamMentorsFailure = '[ESDP] Get Team Mentors Failure',
  ClearGetTeamMentors = '[ESDP] Clear Get Mentors Students',

  GetIterationCaptainReportsRequest = '[ESDP] Get Iteration Captain Reports Request',
  GetIterationCaptainReportsSuccess = '[ESDP] Get Iteration Captain Reports Success',
  GetIterationCaptainReportsFailure = '[ESDP] Get Iteration Captain Reports Failure',
  ClearGetIterationCaptainReports = '[ESDP] Clear Get Iteration Captain Reports',

  UpdateIteration = '[ESDP] Update Iteration',
  AddIteration = '[ESDP] Add Iteration',
  DeleteIteration = '[ESDP] Delete Iteration',
  DeleteStudentFromTeam = '[ESDP] Delete Student From Team',

  GetTeamDocumentsRequest = '[ESDP] Get Team Documents Request',
  GetTeamDocumentsSuccess = '[ESDP] Get Team Documents Success',
  GetTeamDocumentsFailure = '[ESDP] Get Team Documents Failure',
  ClearGetTeamDocuments = '[ESDP] Clear Get Team Documents',

  GetTeamDocumentByIdRequest = '[ESDP] Get Team Document By Id Request',
  GetTeamDocumentByIdSuccess = '[ESDP] Get Team Document By Id Success',
  GetTeamDocumentByIdFailure = '[ESDP] Get Team Document By Id Failure',
  ClearGetTeamDocumentById = '[ESDP] Clear Get Team Document By Id',

  GetTeamMaterialsRequest = '[ESDP] Get Team Materials Request',
  GetTeamMaterialsSuccess = '[ESDP] Get Team Materials Success',
  GetTeamMaterialsFailure = '[ESDP] Get Team Materials Failure',
  ClearGetTeamMaterials = '[ESDP] Clear Get Team Materials',

  UpdateIterationReview = '[ESDP] Update Iteration Review',
  UpdateIterationStudentsReview = '[ESDP] Update Iteration Students Review',
  UpdateIterationCaptainReport = '[ESDP] Update Iteration Captain Report',
  UpdateIterationStatus = '[ESDP] Update Iteration Status',
}

export class GetESDPTeamRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamRequest;

  constructor(public id: number) {}
}

export class GetESDPTeamSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamSuccess;

  constructor(public payload: IESDPTeam) {}
}

export class GetESDPTeamFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamFailure;
}

export class ClearGetESDPTeam implements Action {
  public readonly type = EESDPViewActions.ClearGetTeam;
}

export class GetESDPTeamsRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamsRequest;

  constructor(public qParams?: { group?: number; is_active?: boolean }) {}
}

export class GetESDPTeamsSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamsSuccess;

  constructor(public payload: IESDPGroupTeams[]) {}
}

export class GetESDPTeamsFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPTeams implements Action {
  public readonly type = EESDPViewActions.ClearGetTeams;
}

export class GenerateESDPTeamsRequest implements Action {
  public readonly type = EESDPViewActions.GenerateESDPTeamsRequest;

  constructor(public qParams: { group_id: number; teams_count: number }) {}
}

export class GenerateESDPTeamsSuccess implements Action {
  public readonly type = EESDPViewActions.GenerateESDPTeamsSuccess;

  constructor(public payload: IESDPTeams[]) {}
}

export class GenerateESDPTeamsFailure implements Action {
  public readonly type = EESDPViewActions.GenerateESDPTeamsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGenerateESDPTeams implements Action {
  public readonly type = EESDPViewActions.ClearGenerateESDPTeams;
}

export class ChangeGeneratedESDPTeams implements Action {
  public readonly type = EESDPViewActions.ChangeGeneratedESDPTeams;

  constructor(
    public user: IESDPTeamUser,
    public dropIndex: number,
    public dragIndex: number
  ) {}
}

export class GetFreeTimeGraphRequest implements Action {
  public readonly type = EESDPViewActions.GetFreeTimeGraphRequest;

  constructor(public id: number) {}
}

export class GetFreeTimeGraphSuccess implements Action {
  public readonly type = EESDPViewActions.GetFreeTimeGraphSuccess;

  constructor(public data: IESDPFreeTimeGraph) {}
}

export class GetFreeTimeGraphFailure implements Action {
  public readonly type = EESDPViewActions.GetFreeTimeGraphFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetFreeTimeGraph implements Action {
  public readonly type = EESDPViewActions.ClearGetFreeTimeGraph;
}

export class GetESDPIterationsRequest implements Action {
  public readonly type = EESDPViewActions.GetIterationsRequest;

  constructor(public qParams?: IESDPIterationsQParams) {}
}

export class GetESDPIterationsSuccess implements Action {
  public readonly type = EESDPViewActions.GetIterationsSuccess;

  constructor(public payload: IESDPTeamIteration[]) {}
}

export class GetESDPIterationsFailure implements Action {
  public readonly type = EESDPViewActions.GetIterationsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPIterations implements Action {
  public readonly type = EESDPViewActions.ClearGetIterations;
}

export class GetESDPIterationByIdRequest implements Action {
  public readonly type = EESDPViewActions.GetIterationByIdRequest;

  constructor(public id: number) {}
}

export class GetESDPIterationByIdSuccess implements Action {
  public readonly type = EESDPViewActions.GetIterationByIdSuccess;

  constructor(public payload: IESDPTeamIteration) {}
}

export class GetESDPIterationByIdFailure implements Action {
  public readonly type = EESDPViewActions.GetIterationByIdFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPIterationById implements Action {
  public readonly type = EESDPViewActions.ClearGetIterationById;
}

export class GetESDPIterationReviewByIdRequest implements Action {
  public readonly type = EESDPViewActions.GetIterationReviewByIdRequest;

  constructor(public id: number) {}
}

export class GetESDPIterationReviewByIdSuccess implements Action {
  public readonly type = EESDPViewActions.GetIterationReviewByIdSuccess;

  constructor(public payload: IESDPIterationReview) {}
}

export class GetESDPIterationReviewByIdFailure implements Action {
  public readonly type = EESDPViewActions.GetIterationReviewByIdFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPIterationReviewById implements Action {
  public readonly type = EESDPViewActions.ClearGetIterationReviewById;
}

export class GetESDPTeamStudentsRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamStudentsRequest;

  constructor(public teamId: number, public qParams?: { status: string }) {}
}

export class GetESDPTeamStudentsSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamStudentsSuccess;

  constructor(public payload: IUsersPagination) {}
}

export class GetESDPTeamStudentsFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamStudentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPTeamStudents implements Action {
  public readonly type = EESDPViewActions.ClearGetTeamStudents;
}

export class GetESDPTeamMentorsRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamMentorsRequest;

  constructor(public teamId: number, public qParams?: { status: string }) {}
}

export class GetESDPTeamMentorsSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamMentorsSuccess;

  constructor(public payload: IUsersPagination) {}
}

export class GetESDPTeamMentorsFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamMentorsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPTeamMentors implements Action {
  public readonly type = EESDPViewActions.ClearGetTeamMentors;
}

export class SetCurrentESDPIteration implements Action {
  public readonly type = EESDPViewActions.SetCurrentIteration;

  constructor(public payload: IESDPTeamIteration) {}
}

export class ClearCurrentESDPIteration implements Action {
  public readonly type = EESDPViewActions.ClearCurrentIteration;
}

export class GetESDPIterationCaptainReportsRequest implements Action {
  public readonly type = EESDPViewActions.GetIterationCaptainReportsRequest;

  constructor(public id: number) {}
}

export class GetESDPIterationCaptainReportsSuccess implements Action {
  public readonly type = EESDPViewActions.GetIterationCaptainReportsSuccess;

  constructor(public payload: IESDPCaptainReports) {}
}

export class GetESDPIterationCaptainReportsFailure implements Action {
  public readonly type = EESDPViewActions.GetIterationCaptainReportsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetESDPIterationCaptainReports implements Action {
  public readonly type = EESDPViewActions.ClearGetIterationCaptainReports;
}

export class UpdateESDPIteration implements Action {
  public readonly type = EESDPViewActions.UpdateIteration;

  constructor(public payload: IESDPTeamIteration) {}
}

export class AddESDPIteration implements Action {
  public readonly type = EESDPViewActions.AddIteration;

  constructor(public payload: IESDPTeamIteration) {}
}

export class DeleteESDPIteration implements Action {
  public readonly type = EESDPViewActions.DeleteIteration;

  constructor(public payload: number) {}
}

export class DeleteStudentFromESDPTeam implements Action {
  public readonly type = EESDPViewActions.DeleteStudentFromTeam;

  constructor(public studentId: number) {}
}

export class GetTeamDocumentsRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentsRequest;

  constructor(
    public qParams?: { team_id: number; page_size?: number; page?: number }
  ) {}
}

export class GetTeamDocumentsSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentsSuccess;

  constructor(public documents: IESDPTeamDocuments) {}
}

export class GetTeamDocumentsFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTeamDocuments implements Action {
  public readonly type = EESDPViewActions.ClearGetTeamDocuments;
}

export class GetTeamDocumentByIdRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentByIdRequest;

  constructor(public id: number) {}
}

export class GetTeamDocumentByIdSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentByIdSuccess;

  constructor(public document: IESDPTeamDocument) {}
}

export class GetTeamDocumentByIdFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamDocumentByIdFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTeamDocumentById implements Action {
  public readonly type = EESDPViewActions.ClearGetTeamDocumentById;
}

export class GetTeamMaterialsRequest implements Action {
  public readonly type = EESDPViewActions.GetTeamMaterialsRequest;

  constructor(public team_id: number) {}
}

export class GetTeamMaterialsSuccess implements Action {
  public readonly type = EESDPViewActions.GetTeamMaterialsSuccess;

  constructor(public materials: IESDPTeamMaterials[]) {}
}

export class GetTeamMaterialsFailure implements Action {
  public readonly type = EESDPViewActions.GetTeamMaterialsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTeamMaterials implements Action {
  public readonly type = EESDPViewActions.ClearGetTeamMaterials;
}

export class UpdateIterationReview implements Action {
  public readonly type = EESDPViewActions.UpdateIterationReview;

  constructor(public payload: IESDPIterationReview) {}
}

export class UpdateESDPIterationStudentsReview implements Action {
  public readonly type = EESDPViewActions.UpdateIterationStudentsReview;

  constructor(public payload: IESDPIterationReview) {}
}

export class UpdateESDPIterationCaptainReport implements Action {
  public readonly type = EESDPViewActions.UpdateIterationCaptainReport;

  constructor(
    public index: number,
    public payload: IESDPCaptainReportsStudent
  ) {}
}

export class UpdateESDPIterationStatus implements Action {
  public readonly type = EESDPViewActions.UpdateIterationStatus;

  constructor(public isActive: boolean) {}
}

export type ESDPViewActions =
  | GetESDPTeamRequest
  | GetESDPTeamSuccess
  | GetESDPTeamFailure
  | ClearGetESDPTeam
  | GetESDPTeamsRequest
  | GetESDPTeamsSuccess
  | GetESDPTeamsFailure
  | ClearGetESDPTeams
  | GenerateESDPTeamsRequest
  | GenerateESDPTeamsSuccess
  | GenerateESDPTeamsFailure
  | ClearGenerateESDPTeams
  | ChangeGeneratedESDPTeams
  | GetFreeTimeGraphRequest
  | GetFreeTimeGraphSuccess
  | GetFreeTimeGraphFailure
  | ClearGetFreeTimeGraph
  | GetESDPIterationsRequest
  | GetESDPIterationsSuccess
  | GetESDPIterationsFailure
  | GetESDPIterationByIdRequest
  | GetESDPIterationByIdSuccess
  | GetESDPIterationByIdFailure
  | GetESDPIterationReviewByIdRequest
  | GetESDPIterationReviewByIdSuccess
  | GetESDPIterationReviewByIdFailure
  | ClearGetESDPIterationReviewById
  | ClearGetESDPIterationById
  | ClearGetESDPIterations
  | GetESDPTeamStudentsRequest
  | GetESDPTeamStudentsSuccess
  | GetESDPTeamStudentsFailure
  | ClearGetESDPTeamStudents
  | GetESDPTeamMentorsRequest
  | GetESDPTeamMentorsSuccess
  | GetESDPTeamMentorsFailure
  | GetESDPIterationCaptainReportsRequest
  | GetESDPIterationCaptainReportsSuccess
  | GetESDPIterationCaptainReportsFailure
  | ClearGetESDPIterationCaptainReports
  | ClearGetESDPTeamMentors
  | SetCurrentESDPIteration
  | ClearCurrentESDPIteration
  | UpdateESDPIteration
  | AddESDPIteration
  | DeleteESDPIteration
  | DeleteStudentFromESDPTeam
  | GetTeamDocumentsRequest
  | GetTeamDocumentsSuccess
  | GetTeamDocumentsFailure
  | ClearGetTeamDocuments
  | GetTeamDocumentByIdRequest
  | GetTeamDocumentByIdSuccess
  | GetTeamDocumentByIdFailure
  | ClearGetTeamDocumentById
  | GetTeamMaterialsRequest
  | GetTeamMaterialsSuccess
  | GetTeamMaterialsFailure
  | ClearGetTeamMaterials
  | UpdateIterationReview
  | UpdateESDPIterationStudentsReview
  | UpdateESDPIterationCaptainReport
  | UpdateESDPIterationStatus;
